import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-no-permission',
  templateUrl: './page-no-permission.component.html',
  styleUrls: ['./page-no-permission.component.scss']
})
export class PageNoPermissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
